import _debounce from 'lodash/debounce';
import React, { useCallback } from 'react';
interface CustomInputProps {
  id: string;
  placeHolder: string;
  className: string;
  handleSearchField: any;
  setSearchQuery?: any;
  searchText?: any;
  value?: any;
}

const SearchField: React.FC<CustomInputProps> = ({
  id,
  placeHolder,
  className,
  handleSearchField,
  setSearchQuery,
  searchText,
  value,
}) => {
  const debounceFn = useCallback(_debounce(handleSearchField, 300), []);
  // const [searchText, setSearchText] = useState('');

  return (
    <div className='relative w-100'>
      <input
        // type='search'
        style={{ paddingRight: '45px' }}
        className={className}
        id={id}
        placeholder={placeHolder}
        onKeyUp={(e: any) =>
          e.keyCode === 13 ? handleSearchField(e.target.value) : null
        }
        value={value && value}
        onChange={(e) => {
          setSearchQuery && setSearchQuery(e.target.value);
          debounceFn(e.target.value);
          if (e.target.value === '') {
            handleSearchField(e.target.value);
          }
        }}
      />

      <div className='search-icon'>
        {/* {!searchText && (
          <span>
            <img src={cancel} alt={search} />
          </span>
        )}
        {searchText && (
          <span>
            <img src={search} alt={search} />
          </span>
        )} */}
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
        >
          <path
            d='M6.84236 13.684C8.06403 13.6837 9.25737 13.3546 10.3 12.7387C10.7351 12.4817 11.2993 12.5089 11.6566 12.8662L14.186 15.3954C14.5199 15.7293 15.0613 15.7293 15.3953 15.3954C15.7292 15.0614 15.7292 14.5199 15.3953 14.186L12.8662 11.657C12.5088 11.2997 12.4817 10.7353 12.7389 10.3002C13.3551 9.25743 13.6844 8.06389 13.6847 6.84199C13.6847 3.06949 10.6151 0 6.84236 0C3.06965 0 0 3.06949 0 6.84199C0 10.6145 3.06965 13.684 6.84236 13.684ZM6.84236 1.7105C9.67253 1.7105 11.9741 4.01197 11.9741 6.84199C11.9741 9.67201 9.67253 11.9735 6.84236 11.9735C4.01219 11.9735 1.71059 9.67201 1.71059 6.84199C1.71059 4.01197 4.01219 1.7105 6.84236 1.7105Z'
            fill='#808080'
          />
        </svg>
      </div>
    </div>
  );
};

export default SearchField;
